module.exports = __webpack_public_path__ + "img/spinner-green-24.6ac18180.gif";